import React, { Component } from 'react'
import { translation } from '../../../utils/helpers'

import Check from '../../../shared/elements/check'
import Panel from '../../../shared/elements/panel'
import Divider from '../../../shared/elements/divider'
import Expand from '../../../shared/elements/expand'

import NotificationItem from './notificationItem'
class NotificationsArea extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: true
    }
  }

  render () {
    let allNotification = this.props.notifications

    const toggleValue = (value) => {
      this.setState({
        open: value
      })
    }

    return (
      <div className='status-report status-report-wrap'>
        <Panel title={translation(1243)}>
          <div className={'status-report__content'}>
            <Expand defaultOpen={this.state.open} title={this.state.open ? translation(18287) : translation(18286)} alignRight onClick={toggleValue}>
              {allNotification.length > 0 && allNotification.map(i => <NotificationItem key={i.Id} data={i} />)}
            </Expand>
            {!this.state.open && allNotification.length > 0 && <NotificationItem key={allNotification[0].Id} data={allNotification[0]} />}
            <Divider size={4} />
            <Check name='AllowedSMS' labelText={18245} labelAlignment='r' onChange={this.props.onChangeCbx} checked={this.props.notificationSettings.AllowedSMS || false} />
            <Check name='AllowedEmail' labelText={18246} labelAlignment='r' onChange={this.props.onChangeCbx} checked={this.props.notificationSettings.AllowedEmail || false} />
          </div>
        </Panel>
      </div>
    )
  }
}

export default NotificationsArea



// WEBPACK FOOTER //
// ./src/app/pages/CarOwnerPortal/components/notificationsArea.js